/** @enum string */
const PersonType = Object.freeze({
  FISICA: 'F',
  JURIDICA: 'J'
})

export default PersonType
